import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-indent', {
    paddingLeft: '18px',
});

cssRule('.tb-scroll-settings', {
    paddingBottom: '35px',
});

cssRule('.tb-settings-banner', {
    height: '35px',
    paddingLeft: '85px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
});

cssRule('.tb-settings-container', {
    marginLeft: '85px',
    width: '508px',
});

cssRule('.tb-settings-container .tb-site-url-preview', {
    overflow: 'visible',
});

cssRule('.tb-responsive-settings-container', {
    marginRight: '85px',
    width: 'inherit',
});

cssRule('.tb-settings-info-container', {
    marginLeft: '85px',
});

cssRule('.tb-settings-section', {
    paddingTop: '35px',
    paddingBottom: '6px',
});

cssRule('.tb-settings-title', {
    fontSize: '20px',
    paddingBottom: '12px',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-settings-group-name', {
    fontSize: '15px',
    fontWeight: 'bold',
    paddingBottom: '12px',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-settings-subgroup-name', {
    fontSize: '13px',
    fontWeight: 'bold',
    paddingBottom: '12px',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-settings-group-name-message', {
    paddingLeft: '10px',
    fontSize: '12px',
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    fontFamily: '$headerFont',
});

cssRule('.tb-settings-subheader', {
    fontWeight: 'normal',
    fontSize: '12px',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-settings-control-grouping', {
    border: 'none',
});

cssRule('.tb-settings-control', {
    paddingBottom: '6px',
    minHeight: '23px',
});

cssRule('.tb-settings-control span', {
    cursor: 'pointer',
});

cssRule('.tb-settings-control-with-message', {
    paddingBottom: '6px',
    height: '35px',
});

cssRule('.tb-settings-control-with-message span', {
    cursor: 'pointer',
});

cssRule('.tb-server-settings-control', {
    paddingBottom: '18px',
    height: '23px',
});

cssRule('.tb-server-settings-control span', {
    cursor: 'pointer',
});

cssRule('.tb-settings-control-with-warning', {
    paddingBottom: 0,
});

cssRule('.tb-settings-control-with-warning span', {
    cursor: 'pointer',
});

cssRule('.tb-settings-msg', {
    paddingBottom: '12px',
});

cssRule('.tb-settings-msg-pad-top', {
    paddingBottom: '12px',
    paddingTop: '12px',
});

cssRule('.tb-settings-msg-italicized-light', {
    paddingBottom: '12px',
    color: applyColor(DesignTokens.color.font.default.subtle, '#c9c9c9'),
    fontStyle: 'italic',
});

cssRule('.tb-settings-separator', {
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
});

cssRule('.tb-settings-form-actions', {
    position: 'relative',
    display: 'inline-block',
    left: '500px',
    margin: '6px 0',
});

cssRule('.tb-static-grid-table-settings-width', {
    width: '508px',
});

cssRule('.tb-static-grid-table-product-key-width', {
    width: '1100px',
});

cssRule('.tb-static-grid-table-settings-min-width', {
    minWidth: '508px',
});

cssRule('.tb-static-grid-table-settings-max-width', {
    maxWidth: '508px',
});

cssRule('.tb-site-dialog', {
    padding: '12px',
    height: '430px',
    width: '600px',
    overflowX: 'hidden',
    overflowY: 'scroll',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-warning-text', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
    marginTop: '3px',
    paddingLeft: '21px',
});

cssRule('.tb-language-locale-dropdown-content', {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '421.2px',
});

cssRule('.tb-time-zone-dropdown-content', {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '421.2px',
});

cssRule('.settings-table-row-color0', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.settings-table-row-color1', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-flex-space-between', {
    display: 'flex',
    justifyContent: 'space-between',
    '-webkit-justify-content': 'space-between',
});

cssRule('.tb-encryption-success', {
    display: 'flex',
});

cssRule('.tb-encryption-warning', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
    flex: 1,
});

cssRule('.tb-encryption-stats', {
    marginRight: '12px',
});

cssRule('.tb-encryption-status-description', {
    marginRight: '10px',
});

cssRule('.tb-encryption-spinner', {
    verticalAlign: 'sub',
});

cssRule('.tb-encryption-status', {
    paddingLeft: '3px',
});

cssRule('.tb-encryption-error', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
});

cssRule('.encryption-settings-container', {
    width: '385px',
});

cssRule('.popover-encryption-tooltip', {
    width: '185px',
    position: 'relative',
    top: '-50px',
});

cssRule('.ear-learn-more', {
    display: 'block',
    position: 'relative',
    top: '10px',
});

cssRule('.tb-settings-pad-bottom', {
    paddingBottom: '12px',
});

cssRule('.tb-setting-description-indent', {
    marginLeft: '21px',
});

